module.exports = __webpack_public_path__ + "img/acquapalace-kantaoui-tunisia_03.5fd737c1.jpeg";